module.exports = __webpack_public_path__ + "img/logo.99daff28.png";